import React from 'react';

export const CheckIcon: React.FunctionComponent = () => (
  <svg
    style={{ width: 'var(--checkbox-size)' }}
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.02773 1.30485C9.25555 0.981013 9.70331 0.902785 10.0278 1.13012C10.3524 1.35745 10.4308 1.80426 10.2029 2.12809L5.58293 8.69517C5.34404 9.03473 4.86695 9.10144 4.54373 8.84048L1.26638 6.1944C0.958131 5.94553 0.910431 5.49443 1.15984 5.18684C1.40924 4.87925 1.86131 4.83166 2.16956 5.08053L4.84936 7.24415L9.02773 1.30485Z"
      fill="var(--checkbox-color-fill)"
      stroke="var(--checkbox-color-fill)"
    />
  </svg>
);
